import { render, staticRenderFns } from "./reply.vue?vue&type=template&id=06894eb5&scoped=true&"
import script from "./reply.vue?vue&type=script&lang=js&"
export * from "./reply.vue?vue&type=script&lang=js&"
import style0 from "./reply.vue?vue&type=style&index=0&id=06894eb5&scoped=true&lang=css&"
import style1 from "./reply.vue?vue&type=style&index=1&id=06894eb5&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06894eb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06894eb5')) {
      api.createRecord('06894eb5', component.options)
    } else {
      api.reload('06894eb5', component.options)
    }
    module.hot.accept("./reply.vue?vue&type=template&id=06894eb5&scoped=true&", function () {
      api.rerender('06894eb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/internalAudit/components/reply.vue"
export default component.exports